import React from 'react'
import P from '../../../commons/P'
import styled from 'styled-components'
import {beUrl} from "../../../../config";

const Disclaimer = () => {

  return (
    <DisclaimerContainer>
      <P style={{ marginBottom: 0 }}>
        <Small>* Campi obbligatori.</Small>
      </P>
      <P style={{ marginBottom: 0 }}>
        <Small style={{ width: '100%' }}>
          ** L'invio della richiesta equivale al conferimento del consenso per la finalità
          di cui al punto 2 dell’informativa, anche per l’utilizzo di tecniche di
          comunicazione a distanza, facoltativo ma necessario per offrirti il servizio.{' '}
            <a style={{ color: 'inherit', textDecoration: 'underline', cursor: 'pointer' }} href={`${beUrl}/privacy`}>
            Informativa privacy completa
          </a>
          .
        </Small>
      </P>
    </DisclaimerContainer>
  )
}

// region Style
const Small = styled.small`
  font-size: 1.2rem;
`
const DisclaimerContainer = styled.div`
  text-align: initial;
  width: 100%;
  margin: 0 .5rem;
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 1em;
`
// endregion


export default Disclaimer
